/* ZaragozaShop 2.0 — lógica de conversión */
(function () {
  'use strict';
  var Z = window.ZS || {};
  var $ = function (id) { return document.getElementById(id); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- dinero ---------- */
  function money(cents) {
    var fmt = Z.money_format || '{{amount_with_comma_separator}}€';
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace('.', ',');
    var parts = withComma.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var comma = parts.join(',');
    var dot = amount;
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/g, dot);
  }
  function t(key, vars) {
    var s = (Z.strings && Z.strings[key]) || '';
    if (vars) Object.keys(vars).forEach(function (k) {
      s = s.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}', 'g'), vars[k]);
    });
    return s;
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('toast'); if (!el) return;
    el.textContent = msg; el.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('on'); }, 2200);
  }
  window.ZStoast = toast;

  /* ---------- carrito ---------- */
  var cartState = null;

  function fetchCart() {
    return fetch(Z.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; renderCart(c); return c; });
  }

  function addToCart(id, qty) {
    return fetch(Z.routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { toast(res.description || res.message); return null; }
      toast(t('added'));
      return fetchCart();
    });
  }
  window.ZSaddToCart = addToCart;

  var busy = false;
  function changeLine(line, quantity) {
    if (busy) return Promise.resolve(cartState);
    busy = true;
    return fetch(Z.routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (c) {
      busy = false; cartState = c; renderCart(c); return c;
    }).catch(function () { busy = false; });
  }
  window.ZSchangeLine = changeLine;
  window.ZSlineChange = function (line, qty) {
    changeLine(line, qty).then(function () { window.location.reload(); });
  };

  function renderCart(cart) {
    var n = cart.item_count;
    qsa('#cartN, #drCount').forEach(function (el) { el.textContent = n; });
    var box = $('drItems');
    if (box) {
      if (!cart.items.length) {
        box.innerHTML = '<div class="dr-empty"><p>' + t('empty') + '</p><p style="margin-top:6px">' + t('empty_sub') + '</p>' +
          '<a class="btn btn-ink" style="margin-top:16px" href="/collections/all">' + t('keep_shopping') + '</a></div>';
      } else {
        box.innerHTML = cart.items.map(function (i, idx) {
          var img = i.image
            ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="">'
            : '<svg><use href="#i-bag"/></svg>';
          var variant = (i.variant_title && i.variant_title.indexOf('Default') === -1) ? i.variant_title : (i.product_type || '');
          return '<div class="ci">' +
            '<a class="ci-img g1" href="' + i.url + '">' + img + '</a>' +
            '<div class="ci-info"><b>' + i.product_title + '</b><span class="var">' + variant + '</span><br>' +
            '<span class="qty"><button type="button" data-line="' + (idx + 1) + '" data-qty="' + (i.quantity - 1) + '" aria-label="-">&minus;</button>' +
            '<span>' + i.quantity + '</span>' +
            '<button type="button" data-line="' + (idx + 1) + '" data-qty="' + (i.quantity + 1) + '" aria-label="+">+</button></span></div>' +
            '<div class="ci-right"><span class="pr">' + money(i.final_line_price) + '</span>' +
            '<button type="button" class="ci-rm" data-line="' + (idx + 1) + '" data-qty="0">' + t('remove') + '</button></div>' +
            '</div>';
        }).join('');
        qsa('[data-line]', box).forEach(function (b) {
          b.addEventListener('click', function () { changeLine(Number(b.dataset.line), Number(b.dataset.qty)); });
        });
      }
    }
    var total = $('drTotal'); if (total) total.textContent = money(cart.total_price);

    var goal = $('shipGoal');
    if (goal) {
      var threshold = Z.free_shipping_threshold || 0;
      var left = Math.max(0, threshold - cart.total_price);
      var pct = threshold ? Math.min(100, (cart.total_price / threshold) * 100) : 100;
      var msg = left <= 0 ? t('free_ship_done')
        : (left < 100 ? t('free_ship_almost') : t('free_ship_left', { amount: '<b>' + money(left) + '</b>' }));
      goal.innerHTML = msg + '<div class="ship-track"><i style="width:' + pct + '%"></i></div>';
    }
    renderUpsells(cart);
  }

  /* ---------- upsells inteligentes ---------- */
  var upsellCache = null;
  function renderUpsells(cart) {
    var box = $('upsellBox'), rows = $('upRows');
    if (!box || !rows) return;
    if (!cart.items.length) { box.hidden = true; return; }
    box.hidden = true;

    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var maxPrice = Z.upsell_max_price || 4000;
    var seedId = cart.items[cart.items.length - 1].product_id;

    function paint(list) {
      var picks = list.filter(function (p) {
        return p.available && !inCart[p.id] && p.price_min <= maxPrice;
      }).slice(0, 3);
      if (!picks.length) { rows.innerHTML = ''; box.hidden = true; return; }
      box.hidden = false;
      rows.innerHTML = picks.map(function (p) {
        var vid = p.variants && p.variants[0] ? p.variants[0].id : null;
        var img = p.featured_image
          ? '<img src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2') + '" alt="">'
          : '<svg style="width:24px;height:24px"><use href="#i-bag"/></svg>';
        var was = (p.compare_at_price_min > p.price_min)
          ? ' <s>' + money(p.compare_at_price_min) + '</s>' : '';
        return '<div class="up-row"><span class="bn-ic g1">' + img + '</span>' +
          '<span class="nm">' + p.title + '<small>' + money(p.price_min) + was + '</small></span>' +
          '<button type="button" class="up-add" data-up="' + vid + '">' + t('add') + '</button></div>';
      }).join('');
      qsa('.up-add', rows).forEach(function (b) {
        b.addEventListener('click', function () {
          b.disabled = true; b.textContent = t('added_short');
          addToCart(b.dataset.up, 1);
        });
      });
    }

    if (upsellCache) { paint(upsellCache); return; }
    fetch('/recommendations/products.json?product_id=' + seedId + '&limit=10&intent=complementary')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.products && d.products.length) { upsellCache = d.products; paint(d.products); }
        else return fetch('/recommendations/products.json?product_id=' + seedId + '&limit=10')
          .then(function (r) { return r.json(); })
          .then(function (d2) { upsellCache = d2.products || []; paint(upsellCache); });
      })
      .catch(function () { rows.innerHTML = ''; });
  }

  /* ---------- drawer ---------- */
  window.ZSopenCart = function () {
    var n = $('navDrawer'); if (n) n.classList.remove('on');
    document.body.classList.remove('nav-open');
    var d = $('drawer'), o = $('ovl'); if (o) o.classList.remove('clear');
    if (d) d.classList.add('on');
    if (o) o.classList.add('on');
    lockScroll(true);
    fetchCart();
  };
  window.ZScloseCart = function () {
    var d = $('drawer'), o = $('ovl');
    if (d) d.classList.remove('on');
    var navOpen = $('navDrawer') && $('navDrawer').classList.contains('on');
    if (!navOpen) {
      if (o) o.classList.remove('on');
      lockScroll(false);
    }
  };

  /* ---------- botones añadir de las tarjetas ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-zs-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    addToCart(btn.dataset.zsAdd, 1).then(function () {
      btn.disabled = false;
      window.ZSopenCart();
    });
  });

  /* ---------- carruseles ---------- */
  window.ZSrail = function (id, dir) {
    var r = $(id); if (!r) return;
    var card = r.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 14 : 280;
    r.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
  };

  /* ---------- cajón de menú ---------- */
  /* bloqueo de scroll del fondo (también en iOS: body fijo + restaurar posición) */
  var lockY = 0, locked = false;
  function lockScroll(on) {
    on = !!on;
    if (on === locked) return;
    var b = document.body, st = b.style;
    var wrap = document.getElementById('shopify-section-header');
    var hdr = document.querySelector('header.site');
    if (on) {
      lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
      /* la cabecera pasa a fija en el mismo sitio donde se ve ahora (el sticky deja de funcionar con el body fijo) */
      if (wrap && hdr) {
        var r = wrap.getBoundingClientRect();
        wrap.style.height = wrap.offsetHeight + 'px';
        hdr.style.position = 'fixed'; hdr.style.top = Math.max(0, r.top) + 'px';
        hdr.style.left = '0'; hdr.style.right = '0'; hdr.style.zIndex = '5';
      }
      st.position = 'fixed'; st.top = (-lockY) + 'px'; st.left = '0'; st.right = '0'; st.width = '100%';
      st.overflow = 'hidden';
      document.documentElement.classList.add('zs-locked');
    } else {
      st.position = ''; st.top = ''; st.left = ''; st.right = ''; st.width = ''; st.overflow = '';
      if (wrap && hdr) { wrap.style.height = ''; hdr.style.position = ''; hdr.style.top = ''; hdr.style.left = ''; hdr.style.right = ''; hdr.style.zIndex = ''; }
      document.documentElement.classList.remove('zs-locked');
      /* restaurar la posición al instante, sin animación de scroll suave */
      var de = document.documentElement, prevSB = de.style.scrollBehavior;
      de.style.scrollBehavior = 'auto';
      window.scrollTo(0, lockY);
      de.style.scrollBehavior = prevSB;
    }
    locked = on;
  }
  window.ZSopenNav = function () {
    var n = $('navDrawer'), o = $('ovl'), b = $('navBtn');
    if (!n) return;
    n.classList.add('on'); if (o) { o.classList.add('on'); o.classList.add('clear'); }
    document.body.classList.add('nav-open');
    if (b) b.setAttribute('aria-expanded', 'true');
    lockScroll(true);
    var first = n.querySelector('.nav-links a'); if (first) first.focus();
  };
  window.ZScloseNav = function () {
    var n = $('navDrawer'), b = $('navBtn');
    if (n) n.classList.remove('on');
    document.body.classList.remove('nav-open');
    if (b) b.setAttribute('aria-expanded', 'false');
    if (!$('drawer') || !$('drawer').classList.contains('on')) {
      var o = $('ovl'); if (o) o.classList.remove('on');
      lockScroll(false);
    }
  };
  window.ZScloseAll = function () { window.ZScloseNav(); window.ZScloseCart(); };
  window.ZStoggleNav = window.ZSopenNav;

  /* ---------- contador ---------- */
  (function () {
    var cd = $('cd'); if (!cd) return;
    var custom = cd.dataset.deadline;
    function tick() {
      var end;
      if (custom) { end = new Date(custom); if (isNaN(end)) end = null; }
      if (!end || end <= new Date()) { end = new Date(); end.setHours(24, 0, 0, 0); }
      var s = Math.max(0, Math.floor((end - new Date()) / 1000));
      var h = $('cdH'), m = $('cdM'), sec = $('cdS');
      if (h) h.textContent = String(Math.floor(s / 3600)).padStart(2, '0');
      if (m) m.textContent = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      if (sec) sec.textContent = String(s % 60).padStart(2, '0');
    }
    tick(); setInterval(tick, 1000);
  })();

  /* ---------- pack ---------- */
  (function () {
    var b = $('bundleAdd'); if (!b) return;
    b.addEventListener('click', function () {
      var ids = (b.dataset.ids || '').split(',').filter(Boolean);
      if (!ids.length) { toast('Elige los productos del pack en el editor de temas'); return; }
      b.disabled = true;
      fetch(Z.routes.cart_add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
      }).then(function () { b.disabled = false; toast(t('added')); window.ZSopenCart(); });
    });
  })();

  /* ---------- ficha de producto ---------- */
  window.ZSswapImage = function (btn, url) {
    var main = $('pdpMainImg'); if (main) main.src = url;
    qsa('.thumbs button').forEach(function (b) { b.classList.remove('on'); });
    btn.classList.add('on');
  };

  /* ---------- variantes ---------- */
  var VC = null;
  function initVariants() {
    var select = $('variantSelect');
    if (!select) return;
    var groups = qsa('.sizes');
    var variants = qsa('option', select).map(function (o) {
      return {
        id: o.value,
        opts: (o.dataset.options || '').split('~~'),
        available: o.dataset.available === 'true',
        price: o.dataset.price,
        compare: o.dataset.compare,
        save: o.dataset.save,
        onSale: o.dataset.onSale === 'true',
        el: o
      };
    });
    VC = { select: select, groups: groups, variants: variants, chosen: [] };

    groups.forEach(function (g, gi) {
      var on = g.querySelector('button.on') || g.querySelector('button');
      VC.chosen[gi] = on ? on.dataset.value : null;
      qsa('button', g).forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.classList.contains('hard-out')) return;
          VC.chosen[gi] = b.dataset.value;
          qsa('button', g).forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          syncVariants();
        });
      });
    });
    if (!groups.length) { VC.chosen = variants.length ? variants[0].opts : []; }
    syncVariants();
  }

  function findVariant(chosen) {
    for (var i = 0; i < VC.variants.length; i++) {
      var v = VC.variants[i];
      var ok = true;
      for (var j = 0; j < chosen.length; j++) {
        if (chosen[j] !== null && chosen[j] !== v.opts[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function syncVariants() {
    if (!VC) return;

    /* marca qué valores existen y cuáles están agotados con lo ya elegido */
    VC.groups.forEach(function (g, gi) {
      qsa('button', g).forEach(function (b) {
        var test = VC.chosen.slice();
        test[gi] = b.dataset.value;
        var exists = false, sellable = false;
        for (var i = 0; i < VC.variants.length; i++) {
          var v = VC.variants[i], ok = true;
          for (var j = 0; j < test.length; j++) {
            if (j !== gi && test[j] === null) continue;
            if (test[j] !== v.opts[j]) { ok = false; break; }
          }
          if (ok) { exists = true; if (v.available) { sellable = true; break; } }
        }
        b.classList.toggle('out', exists && !sellable);
        b.classList.toggle('hard-out', !exists);
        b.disabled = !exists;
      });
    });

    var match = findVariant(VC.chosen);
    var exact = match && VC.chosen.every(function (c, i) { return c === null || c === match.opts[i]; });

    /* etiqueta "Talla — 42" */
    VC.groups.forEach(function (g, gi) {
      var lbl = document.querySelector('[data-opt-current="' + gi + '"]');
      if (lbl) lbl.textContent = VC.chosen[gi] || '—';
    });

    var addBtn = $('pdpAdd'), buyBtn = $('pdpBuy'), avail = $('pdpAvail');
    var buyPrice = $('pdpBuyPrice'), buyLabel = $('pdpBuyLabel');

    if (!match) {
      if (avail) { avail.textContent = strings.combo_none; avail.className = 'pdp-avail out'; }
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.unavailable; }
      if (buyBtn) { buyBtn.disabled = true; if (buyLabel) buyLabel.textContent = strings.unavailable; if (buyPrice) buyPrice.textContent = ''; }
      return;
    }

    VC.select.value = match.id;

    var now = $('pdpNow'), was = $('pdpWas'), save = $('pdpSave');
    if (now) now.textContent = match.price;
    if (was) { was.textContent = match.compare; was.hidden = !match.onSale; }
    if (save) { save.textContent = strings.you_save + ' ' + match.save; save.hidden = !match.onSale; }
    if (buyPrice) buyPrice.innerHTML = ' — ' + match.price;

    if (match.available) {
      if (avail) { avail.textContent = strings.in_stock_ship; avail.className = 'pdp-avail ok'; }
      if (addBtn) { addBtn.disabled = false; addBtn.textContent = strings.add_to_cart; }
      if (buyBtn) { buyBtn.disabled = false; if (buyLabel) buyLabel.textContent = codLabel; }
    } else {
      if (avail) { avail.textContent = strings.sold_out_note; avail.className = 'pdp-avail out'; }
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.sold_out; }
      if (buyBtn) { buyBtn.disabled = true; if (buyLabel) buyLabel.textContent = strings.sold_out; if (buyPrice) buyPrice.textContent = ''; }
    }
  }

  var strings = (Z.pdp || {});
  var codLabel = (function () { var b = $('pdpBuyLabel'); return b ? b.textContent : ''; })();

  /* galería móvil: deslizar con el dedo, miniaturas con flechas y zoom */
  (function () {
    var slider = $('pdpSlider');
    var thumbs = $('pdpThumbs');
    if (!slider) return;
    var slides = qsa('.slide', slider);
    var btns = thumbs ? qsa('button', thumbs) : [];
    var counter = $('sliderCount');
    var prev = $('thPrev');
    var next = $('thNext');
    var cur = 0;

    function goTo(i) {
      if (!slides[i]) return;
      slider.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }
    function centerThumb(i) {
      var active = btns[i];
      if (!active || !thumbs) return;
      var left = active.offsetLeft - btns[0].offsetLeft - (thumbs.clientWidth / 2) + (active.clientWidth / 2);
      var max = thumbs.scrollWidth - thumbs.clientWidth;
      if (left < 0) left = 0;
      if (left > max) left = max;
      thumbs.scrollTo({ left: left, behavior: 'smooth' });
    }
    function fit(i) {
      var sl = slides[i]; if (!sl) return;
      var w = sl.clientWidth || slider.clientWidth; if (!w) return;
      var ar = parseFloat(getComputedStyle(sl).getPropertyValue('--ar')) || 1;
      slider.classList.add('fit');
      slider.style.height = Math.round(w / ar) + 'px';
    }
    function syncNav() {
      if (prev) prev.disabled = cur <= 0;
      if (next) next.disabled = cur >= slides.length - 1;
    }
    function mark(i) {
      cur = i;
      btns.forEach(function (b, k) { b.classList.toggle('on', k === i); });
      if (counter) { var b = counter.querySelector('b'); if (b) b.textContent = i + 1; }
      centerThumb(i);
      fit(i);
      syncNav();
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { goTo(i); mark(i); });
    });
    if (prev) prev.addEventListener('click', function () { if (cur > 0) { goTo(cur - 1); mark(cur - 1); } });
    if (next) next.addEventListener('click', function () { if (cur < slides.length - 1) { goTo(cur + 1); mark(cur + 1); } });

    function nearest() {
      var x = slider.scrollLeft, base = slides[0] ? slides[0].offsetLeft : 0, best = 0, bd = Infinity;
      for (var k = 0; k < slides.length; k++) {
        var d = Math.abs((slides[k].offsetLeft - base) - x);
        if (d < bd) { bd = d; best = k; }
      }
      return best;
    }
    var t;
    slider.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { mark(nearest()); }, 60);
    }, { passive: true });

    /* zoom a pantalla completa */
    var zoom = $('pdpZoom');
    if (zoom) zoom.addEventListener('click', function () {
      var img = slides[cur] ? slides[cur].querySelector('img') : null;
      if (!img) return;
      var lb = document.createElement('div');
      lb.className = 'zoomlb';
      var big = document.createElement('img');
      big.src = img.currentSrc || img.src;
      big.alt = img.alt || '';
      var cl = document.createElement('button');
      cl.type = 'button';
      cl.className = 'lb-close';
      cl.setAttribute('aria-label', (Z.strings && Z.strings.close) || 'Cerrar');
      cl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      lb.appendChild(big); lb.appendChild(cl);
      function close() { lb.remove(); document.body.classList.remove('lb-open'); document.removeEventListener('keydown', onKey); }
      function onKey(e) { if (e.key === 'Escape') close(); }
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === cl || cl.contains(e.target)) close(); });
      document.addEventListener('keydown', onKey);
      document.body.appendChild(lb);
      document.body.classList.add('lb-open');
    });

    syncNav();
    fit(0);
    window.addEventListener('resize', function () { fit(cur); }, { passive: true });
    slides.forEach(function (sl) {
      var im = sl.querySelector('img');
      if (im && !im.complete) im.addEventListener('load', function () { fit(cur); }, { once: true });
    });
  })();

  (function () {
    var form = $('pdpForm'); if (!form) return;
    initVariants();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = VC && VC.select ? VC.select.value : null;
      if (!id) return;
      var btn = $('pdpAdd');
      if (btn) btn.disabled = true;
      addToCart(id, 1).then(function () {
        if (btn) btn.disabled = false;
        window.ZSopenCart();
      }).catch(function () { if (btn) btn.disabled = false; });
    });
    var buy = $('pdpBuy');
    if (buy) buy.addEventListener('click', function () {
      var id = VC && VC.select ? VC.select.value : null;
      if (!id || buy.disabled) return;
      buy.disabled = true;
      addToCart(id, 1).then(function () {
        window.location.href = (Z.routes && Z.routes.cart) || '/cart';
      }).catch(function () { buy.disabled = false; });
    });
  })();

  /* fechas de envío y entrega */
  (function () {
    var lang = document.documentElement.lang || 'es-ES';
    function isWeekend(d) { return d.getDay() === 0 || d.getDay() === 6; }
    function nextWorking(d) { var x = new Date(d); do { x.setDate(x.getDate() + 1); } while (isWeekend(x)); return x; }
    function fmt(d, opts) { return d.toLocaleDateString(lang, opts); }
    function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

    var now = new Date();
    var CUTOFF = 17;
    var ship = new Date(now);
    if (isWeekend(now) || now.getHours() >= CUTOFF) { ship = nextWorking(now); }
    var deliver = nextWorking(ship);

    var shipsToday = ship.toDateString() === now.toDateString();
    var shipWord = shipsToday ? 'hoy' : fmt(ship, { weekday: 'long' });
    var getWord = fmt(deliver, { weekday: 'long' });
    var shipShort = shipsToday ? 'hoy' : fmt(ship, { weekday: 'short', day: 'numeric' });
    var getShort = fmt(deliver, { weekday: 'short', day: 'numeric' });
    var getLong = fmt(deliver, { weekday: 'long', day: 'numeric', month: 'long' });

    function set(id, val) { var el = $(id); if (el) el.textContent = val; }
    set('pdpEta', getLong);
    set('bandEta', fmt(deliver, { weekday: 'long', day: 'numeric' }));
    set('tlShipWord', shipsToday ? 'hoy' : 'el ' + shipWord);
    set('tlGetWord', 'el ' + getWord);
    set('tlShipDate', shipShort);
    set('tlGetDate', getShort);
    set('tlGetLong', cap(getLong));
  })();

  /* cómpralo junto */
  (function () {
    var box = $('alsoBox'); if (!box) return;
    var rows = $('alsoRows'), totalEl = $('alTot');
    var basePrice = 0;
    var sel = $('variantSelect');
    function baseCents() {
      var txt = ($('pdpNow') || {}).textContent || '0';
      var num = txt.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
      return Math.round(parseFloat(num || '0') * 100);
    }
    var maxPrice = Z.upsell_max_price || 4000;
    fetch('/recommendations/products.json?product_id=' + box.dataset.productId + '&limit=8')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var picks = (d.products || []).filter(function (p) {
          return p.available && p.price_min <= maxPrice;
        }).slice(0, 2);
        if (!picks.length) { box.style.display = 'none'; return; }
        rows.innerHTML = picks.map(function (p, i) {
          var vid = p.variants && p.variants[0] ? p.variants[0].id : '';
          return '<label class="al-row"><input type="checkbox" class="al-chk"' + (i === 0 ? ' checked' : '') +
            ' data-vid="' + vid + '" data-cents="' + p.price_min + '"> ' + p.title +
            '<span class="pr">' + money(p.price_min) + '</span></label>';
        }).join('');
        qsa('.al-chk', rows).forEach(function (c) { c.addEventListener('change', updateTotal); });
        updateTotal();
      })
      .catch(function () { box.style.display = 'none'; });

    function updateTotal() {
      basePrice = baseCents();
      var sum = basePrice;
      qsa('.al-chk:checked', rows).forEach(function (c) { sum += Number(c.dataset.cents); });
      if (totalEl) totalEl.textContent = money(sum);
    }

    var addAll = $('alsoAdd');
    if (addAll) addAll.addEventListener('click', function () {
      var items = [{ id: Number(sel.value), quantity: 1 }];
      qsa('.al-chk:checked', rows).forEach(function (c) {
        if (c.dataset.vid) items.push({ id: Number(c.dataset.vid), quantity: 1 });
      });
      addAll.disabled = true;
      fetch(Z.routes.cart_add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function () { addAll.disabled = false; toast(t('added')); window.ZSopenCart(); });
    });
  })();

  /* ---------- popup ---------- */
  window.ZSclosePop = function () {
    var p = $('pop'); if (p) p.classList.remove('on');
    try { localStorage.setItem('zs_pop', '1'); } catch (e) {}
  };
  (function () {
    var p = $('pop'); if (!p) return;
    var seen = false;
    try { seen = localStorage.getItem('zs_pop') === '1'; } catch (e) {}
    if (seen) return;
    setTimeout(function () { p.classList.add('on'); }, 14000);
  })();

  /* ---------- teclado ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { window.ZScloseAll(); window.ZSclosePop(); }
  });

  /* ---------- la columna de fotos acompaña, sin dejar hueco ---------- */
  (function () {
    var gal = document.querySelector('.pdp-gal');
    var info = document.querySelector('.pdp-info');
    if (!gal || !info) return;
    var mosaic = gal.querySelector('.pdp-mosaic');
    if (mosaic && !mosaic.children.length) { mosaic.style.display = 'none'; }

    function fit() {
      gal.classList.remove('is-short');
      if (window.innerWidth < 880) return;
      if (info.offsetHeight - gal.offsetHeight > 160) { gal.classList.add('is-short'); }
    }
    fit();
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fit); }
  })();

  /* ---------- recomendaciones de la ficha ---------- */
  (function () {
    var box = $('pdpRecs'); if (!box || !box.dataset.url) return;
    fetch(box.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('pdpRecs');
        if (fresh && fresh.innerHTML.trim()) { box.innerHTML = fresh.innerHTML; }
        if (!box.innerHTML.trim()) { var sec = $('recs-sec'); if (sec) sec.hidden = true; }
      })
      .catch(function () {
        if (!box.innerHTML.trim()) { var sec = $('recs-sec'); if (sec) sec.hidden = true; }
      });
  })();

  /* ---------- init ---------- */
  fetchCart();
})();

/* ===== teléfonos obligatorios en el carrito (contrareembolso) ===== */
(function () {
  var RE = /^[6789]\d{8}$/;
  function norm(v) { return String(v || '').replace(/[\s\-\.\(\)]/g, '').replace(/^(?:\+|00)34/, ''); }
  function boxes() { return Array.prototype.slice.call(document.querySelectorAll('[data-phones]')); }
  function inputs(box) { return { a: box.querySelector('[data-phone="1"]'), b: box.querySelector('[data-phone="2"]'), err: box.querySelector('[data-phone-err]') }; }
  function check(box) {
    var f = inputs(box), a = norm(f.a.value), b = norm(f.b.value), msg = '', bad = null;
    if (!a || !b) { msg = box.getAttribute('data-err-empty'); bad = !a ? f.a : f.b; }
    else if (!RE.test(a)) { msg = box.getAttribute('data-err-es'); bad = f.a; }
    else if (!RE.test(b)) { msg = box.getAttribute('data-err-es'); bad = f.b; }
    else if (a === b) { msg = box.getAttribute('data-err-same'); bad = f.b; }
    return { ok: !msg, msg: msg, bad: bad, a: a, b: b };
  }
  function paint(box, r) {
    var f = inputs(box);
    f.a.classList.toggle('bad', !!(r.bad === f.a));
    f.b.classList.toggle('bad', !!(r.bad === f.b));
    if (f.err) { f.err.textContent = r.msg || ''; f.err.hidden = !r.msg; }
  }
  function clearPaint(box) { var f = inputs(box); f.a.classList.remove('bad'); f.b.classList.remove('bad'); if (f.err) { f.err.hidden = true; } }
  function noteText(box, a, b) {
    return box.getAttribute('data-note-label1') + ': +34 ' + a + ' · ' + box.getAttribute('data-note-label2') + ': +34 ' + b;
  }
  function syncAll(a, b, note) {
    boxes().forEach(function (box) {
      var f = inputs(box);
      if (f.a.value !== a) f.a.value = a;
      if (f.b.value !== b) f.b.value = b;
      var n = box.querySelector('[data-phone-note]'); if (n) n.value = note;
    });
  }
  var saveT;
  function save(box) {
    var r = check(box); if (!r.ok) return;
    var note = noteText(box, r.a, r.b);
    var form = box.closest('form'); var ta = form && form.querySelector('[data-cart-note]');
    if (ta) { var base = ta.value.replace(/\s*\|\s*Tel[^\n]*$/i, '').trim(); note = (base ? base + ' | ' : '') + note; }
    syncAll(r.a, r.b, note);
    clearTimeout(saveT);
    saveT = setTimeout(function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { 'Teléfono principal': r.a, 'Teléfono secundario': r.b }, note: note }) }).catch(function () {});
    }, 250);
  }
  window.ZSphonesOK = function () { var b = boxes()[0]; return b ? check(b).ok : true; };
  window.ZSphonesFocus = function () {
    var box = document.querySelector('#drawer [data-phones]') || boxes()[0]; if (!box) return;
    var r = check(box); paint(box, r);
    (r.bad || inputs(box).a).focus();
  };
  document.addEventListener('submit', function (e) {
    var form = e.target; if (!form || !form.querySelector) return;
    var box = form.querySelector('[data-phones]'); if (!box) return;
    var r = check(box);
    if (!r.ok) { e.preventDefault(); paint(box, r); r.bad.focus(); return; }
    var f = inputs(box); f.a.value = r.a; f.b.value = r.b;
    var n = box.querySelector('[data-phone-note]'); if (n) n.value = noteText(box, r.a, r.b);
    var ta = form.querySelector('[data-cart-note]');
    if (ta) {
      var base = ta.value.replace(/\s*\|\s*Tel[^\n]*$/i, '').trim();
      ta.value = (base ? base + ' | ' : '') + noteText(box, r.a, r.b);
    }
  }, true);
  document.addEventListener('input', function (e) {
    var el = e.target; if (!el || !el.hasAttribute || !el.hasAttribute('data-phone')) return;
    clearPaint(el.closest('[data-phones]'));
  });
  document.addEventListener('change', function (e) {
    var el = e.target; if (!el || !el.hasAttribute || !el.hasAttribute('data-phone')) return;
    var box = el.closest('[data-phones]'); var r = check(box);
    if (r.ok) save(box); else if (norm(el.value)) paint(box, r);
  });
})();

/* ===== filtros de colección: aplicar al marcar, cerrar al tocar fuera ===== */
(function () {
  var form = document.getElementById('fbar'); if (!form) return;
  form.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.type === 'checkbox') form.submit();
  });
  form.addEventListener('submit', function () {
    /* al ordenar con un botón, que no viaje también el sort antiguo */
    var keep = document.getElementById('sortKeep');
    var ae = document.activeElement;
    if (keep && ae && ae.name === 'sort_by') keep.disabled = true;
  });
  document.addEventListener('click', function (e) {
    var open = form.querySelectorAll('details.fdrop[open]');
    open.forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  form.querySelectorAll('details.fdrop').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      form.querySelectorAll('details.fdrop[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
    });
  });
})();
